import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch { localStorage.removeItem("admin_token"); setAdmin(null); }
    setLoading(false);
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("admin_token", data.token);
    setAdmin({ email: data.email, role: data.role });
    return data;
  };

  const logout = () => { localStorage.removeItem("admin_token"); setAdmin(null); };

  return <AuthCtx.Provider value={{ admin, loading, login, logout, refresh }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
